import { render } from "./mStudyDesign.vue?vue&type=template&id=b930a6e0"
import script from "./mStudyDesign.vue?vue&type=script&lang=js"
export * from "./mStudyDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__